// Minimal TOC builder (headings h2-h4)
document.addEventListener('DOMContentLoaded', () => {
  const tocRoot = document.getElementById('js-toc');
  if (!tocRoot) return;

  const headings = [...document.querySelectorAll('.content-body h1, .content-body h2, .content-body h3, .content-body h4')];
  if (!headings.length) return;

  // Build nested list based on level
  let currentLevel = 2;
  let currentOl = tocRoot;
  const stack = [currentOl];

  const ensureLevel = (level) => {
    while (currentLevel < level) {
      const newOl = document.createElement('ol');
      stack[stack.length - 1].lastElementChild?.appendChild(newOl);
      stack.push(newOl);
      currentLevel++;
    }
    while (currentLevel > level) {
      stack.pop();
      currentLevel--;
    }
    currentOl = stack[stack.length - 1];
  };

  headings.forEach((h) => {
    const level = Number(h.tagName.substring(1));
    const id = h.id || h.textContent.trim().toLowerCase().replace(/\s+/g, '-');
    if (!h.id) h.id = id;

    ensureLevel(Math.min(Math.max(level, 2), 4));

    const li = document.createElement('li');
    li.className = `toc-${h.tagName.toLowerCase()}`;
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = h.textContent;
    li.appendChild(a);
    currentOl.appendChild(li);
  });

  // Activate on scroll
  const links = [...tocRoot.querySelectorAll('a')];
  const map = new Map(links.map((a) => [a.getAttribute('href').slice(1), a]));
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const a = map.get(entry.target.id);
      if (!a) return;
      if (entry.isIntersecting) {
        links.forEach((l) => l.classList.remove('is-active'));
        a.classList.add('is-active');
      }
    });
  }, { rootMargin: '0px 0px -70% 0px', threshold: 0.1 });

  headings.forEach((h) => io.observe(h));
});
